import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Sparkles, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login, formatApiErrorDetail } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const user = await login(email, password);
      navigate(user.role === "admin" ? "/admin" : "/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12" data-testid="login-page">
      <div className="w-full max-w-md bg-white rounded-3xl border-2 border-ink shadow-hard-lg p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-10 h-10 bg-brand rounded-xl border-2 border-ink flex items-center justify-center"><Sparkles className="w-5 h-5 text-white" /></div>
          <span className="text-2xl font-black tracking-tighter">Snagly</span>
        </div>
        <h1 className="text-3xl font-black tracking-tight mb-1">Welcome back 👋</h1>
        <p className="text-muted-foreground mb-6">Sign in to continue snagging.</p>

        {error && <div className="bg-brand-pink/10 border-2 border-brand-pink text-brand-pink rounded-xl px-4 py-3 text-sm font-bold mb-4" data-testid="login-error">{error}</div>}

        <form onSubmit={submit} className="space-y-4">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email address"
            className="w-full bg-white border-2 border-ink rounded-xl px-4 py-3 focus:outline-none focus:ring-4 focus:ring-brand/20 font-medium" data-testid="login-email-input" />
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password"
            className="w-full bg-white border-2 border-ink rounded-xl px-4 py-3 focus:outline-none focus:ring-4 focus:ring-brand/20 font-medium" data-testid="login-password-input" />
          <button type="submit" disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full font-bold bg-brand text-white border-2 border-ink shadow-hard-btn hover:translate-y-[3px] hover:shadow-none transition-all disabled:opacity-70" data-testid="login-submit-button">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Sign In"}
          </button>
        </form>

        <p className="text-center text-sm text-muted-foreground mt-6">
          New here? <Link to="/register" className="text-brand font-bold" data-testid="go-to-register">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
